import {
  Feather, MagicWand, MoonStars, FlowerLotus, Crown, Key, HeartStraight, Medal,
  Infinity as InfinityIcon, Mountains, Compass, Scales, Hourglass, Skull, Drop,
  Link as LinkIcon, Lightning, Star, Moon, Sun, Bell, Globe, Sparkle,
  Fire, Wine, Sword, Coins,
} from "@phosphor-icons/react";

const GLYPHS = {
  "The Fool": Feather,
  "The Magician": MagicWand,
  "The High Priestess": MoonStars,
  "The Empress": FlowerLotus,
  "The Emperor": Crown,
  "The Hierophant": Key,
  "The Lovers": HeartStraight,
  "The Chariot": Medal,
  "Strength": InfinityIcon,
  "The Hermit": Mountains,
  "Wheel of Fortune": Compass,
  "Justice": Scales,
  "The Hanged Man": Hourglass,
  "Death": Skull,
  "Temperance": Drop,
  "The Devil": LinkIcon,
  "The Tower": Lightning,
  "The Star": Star,
  "The Moon": Moon,
  "The Sun": Sun,
  "Judgement": Bell,
  "The World": Globe,
};

export const StarEmblem = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <rect x="9" y="9" width="22" height="22" stroke="#C9A84C" strokeWidth="1" opacity="0.9" />
    <rect x="9" y="9" width="22" height="22" stroke="#C9A84C" strokeWidth="1" transform="rotate(45 20 20)" opacity="0.9" />
    <circle cx="20" cy="20" r="6" stroke="#C9A84C" strokeWidth="1" opacity="0.85" />
  </svg>
);

const SUIT_GLYPHS = { Wands: Fire, Cups: Wine, Swords: Sword, Pentacles: Coins };

export const TarotSpreadCard = ({ card, index, flipped }) => {
  const Glyph = (card && (GLYPHS[card.name] || SUIT_GLYPHS[card.suit])) || Sparkle;
  const reversed = card?.orientation === "reversed";

  return (
    <div className="flex flex-col items-center gap-4">
      <p className="text-[11px] uppercase tracking-[0.35em] text-[#bdb2d9] font-heading font-semibold">
        {card ? card.position : "\u00A0"}
      </p>
      <div className={`tarot-flip-card w-full ${flipped ? "flipped" : ""}`} data-testid={`spread-card-${index}`}>
        <div className="tarot-flip-inner relative w-full aspect-[3/5]">
          <div className="tarot-face absolute inset-0 spread-card-back flex items-center justify-center">
            <StarEmblem size={44} />
          </div>
          <div className="tarot-face tarot-face-front absolute inset-0 spread-card-face flex flex-col items-center py-6 px-4">
            {card && (
              <>
                <span className="font-heading text-lg tracking-[0.35em] text-[#c9a84c] pl-[0.35em]">{card.numeral}</span>
                <div className="flex-1 flex items-center justify-center">
                  <Glyph size={62} weight="thin" color="#d9c07a" className={reversed ? "rotate-180" : ""} />
                </div>
                <div className="w-10 h-px bg-[#c9a84c]/60 mb-4" />
                <h3 className="font-heading text-lg sm:text-xl font-semibold tracking-[0.14em] uppercase text-[#efeaf7] text-center leading-snug">
                  {card.name}
                </h3>
                <p className="font-heading italic text-xs text-[#9c93b8] mt-1.5 text-center">
                  {card.keywords.join(" · ")}
                </p>
                {reversed && (
                  <span className="mt-2 text-[9px] uppercase tracking-[0.3em] text-red-300/80">reversed</span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
